// src/MatchContext.tsx
import React, {createContext, useContext, ReactNode, useEffect} from 'react';
import Providers from './context';
import {IEnvConfigType, IMatchEvents, LocaleType, WalletConfigType} from "./types/types";
import useWalletInit from "hooks/useWalletInit"
import useInit from "./hooks/useInit";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {IntlProvider} from 'react-intl';
import {messages} from "./i18n"
import {getDefaultConfig, RainbowKitProvider} from "@rainbow-me/rainbowkit";
import {
    bitgetWallet,
    injectedWallet,
    metaMaskWallet,
    okxWallet,
    walletConnectWallet
} from "@rainbow-me/rainbowkit/wallets";
import {arbitrum, base, bsc, mainnet, optimism, polygon} from "wagmi/chains";
import {matchMain} from "./config/chains/MatchMain";
import {matchTest} from "./config/chains/MatchTest";
import {WagmiProvider} from "wagmi";

const queryClient = new QueryClient();
export const wagmiConfig = getDefaultConfig({
    appName: "MatchID",
    projectId: "9ac6ea7e07860f04616fb311b447dee9",
    wallets: [
        {
            groupName: "Recommended",
            wallets: [
                metaMaskWallet,
                walletConnectWallet,
                okxWallet,
                bitgetWallet,
                injectedWallet,
            ],
        },
    ],
    chains: [mainnet, polygon, optimism, arbitrum, base, matchMain, matchTest, bsc],
});
type MatchContextType = {
    appid: string;
    events?: IMatchEvents;
    login: (data: { token: string }) => Promise<void>;
    theme: "light" | "dark";
    locale?: LocaleType
} & Partial<IEnvConfigType>

export const MatchContext = createContext<MatchContextType | undefined>(undefined);

export const MatchProvider: React.FC<{
    children: ReactNode;
    appid: string;
    events?: IMatchEvents;
    theme?: "light" | "dark",
    endpoints?: IEnvConfigType['endpoints']
    locale?: LocaleType
    wallet: WalletConfigType
}> = ({
          children,
          appid,
          events,
          theme = "light",
          endpoints,
          locale,
          wallet
      }) => {

    const {login, endpoints: realEndPoints, locale: realLocale} = useInit({
        theme,
        appid,
        events,
        endpoints,
        locale
    })

    // matchlog.log('config', {
    //     appid,
    //     events,
    //     theme,
    //     endpoints,
    //     locale,
    //     wallet
    // })
    //

    useWalletInit({
        config: wallet,
    })

    return (
        <IntlProvider locale={realLocale} messages={messages[realLocale]}>
            <WagmiProvider config={wagmiConfig}>
                <QueryClientProvider client={queryClient}>
                    <MatchContext.Provider
                        value={{
                            appid,
                            endpoints: realEndPoints,
                            events,
                            login,
                            theme,
                            locale: realLocale
                        }}
                    >
                        <Providers>{children}</Providers>
                    </MatchContext.Provider>
                </QueryClientProvider>
            </WagmiProvider>
        </IntlProvider>

    );
};

export const useMatch = () => {
    const context = useContext(MatchContext);

    if (context === undefined) {
        throw new Error('useMatch must be used within a MatchProvider');
    }
    return context;
};